module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-4.196c2ff2.png";